import { EVENTS_SEARCH, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    open: false,
    fetching: false,
    query: '',
    results: []
};

function search(state = initialState, action) {
    switch (action.type) {
        case EVENTS_SEARCH.OPEN:
            return { ...state, open: true };
        case EVENTS_SEARCH.CLOSE:
            return initialState;
        case EVENTS_SEARCH.INPUT:
            return { ...state, query: action.query };
        case EVENTS_SEARCH.FETCH_OK:
            return { ...state, results: action.results, fetching: false };
        case EVENTS_SEARCH.CLEAR:
            return { ...state, results: [], query: '', fetching: false };
        case EVENTS_SEARCH.FETCH_START:
            return { ...state, fetching: true };
        case LOCATION_CHANGE:
        case LOGIN.CANCEL:
            return initialState;
        default:
            return state;
    }
}

export default search;
